
import React, { useState ,useEffect} from "react";
import bg from "../../assets/web/images/QU-BG.png";
import qrcode from "../../assets/web/images/qu-code.png";
import {loaderBar ,  apibaseURl ,  changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
const  Deposit = (props) => {
    const [data, setData] = useState({});
    const [isLoading, setisLoading] = useState(true);
    const fetchData = () => {
      fetch(apibaseURl + "wallethistory/"+loggedInCustomerDetails('id'))
        .then(res => res.json())
        .then((result) => {
          if (result.result == true) {
              setisLoading(false);
              setData(result.response);
            }
        }
        )
    } 
  
    useEffect(() => {
      fetchData();
     }, [])
  return (
    <>
       <section className="ivo-section deposite-section" 
        style={{
          backgroundImage: `url(${bg})`
         
        }}
       >
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="ur-scane-img text-center">

                        <div className="qu-scanner">
                            <img src={qrcode} alt="" />

                        </div>
                        <h5>
                            Here you can make payments using a QR code, and you can also
                            share
                            screenshots on WhatsApp with mobile number <strong><a href="">+919888888888.</a></strong>
                          
                        </h5>
                        

                    </div>

                </div>
                <div className="col-lg-6">
                    <div className="text-box qu-content">
                        <h1 className="mb-3 whitecolor">
                          <strong> Scan QR Code</strong>
                        </h1>
                        <p>
                            Welcome to our Deposit page! Here you can make payments using a QR code, and you can also
                            share
                            screenshots on WhatsApp with mobile number +919888888888.
                        </p>
                        <p>
                            QR code payments are a safe and secure way to make payments. All you need to do is scan the
                            QR code with your mobile device and enter the amount you wish to deposit. Your payment will
                            be instantly processed and credited to your account.
                        </p>
                        <p>
                            You can also share screenshots of your payments on WhatsApp with mobile number
                            +919888888888. This will help you keep track of your payments and ensure that your payments
                            are safe and secure.
                        </p>
                        <p>  Thank you for using our Deposit page. We hope you have a great experience!</p>


                    </div>
                </div>
            </div>

        </div>
    </section>
    </>

  );
}

export default Deposit;
